import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { ProjectsRootComponent } from './pages/root/root.page';

export const projectsRoutes: Routes = [
    { path: '', component: ProjectsRootComponent, data: { title: 'Brother Projektprogramm' } },
    { path: '**', pathMatch: 'full', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forChild(projectsRoutes)],
    exports: [RouterModule]
})
export class ProjectsRoutingModule { }
